import React from 'react';
import { ReactComponent as BTCSVG } from 'assets/images/home/assets/BTC.svg';
import { ReactComponent as ETHSVG } from 'assets/images/home/assets/ETH.svg';
import { ReactComponent as DOGESVG } from 'assets/images/home/assets/DOGEB.svg';
import { ReactComponent as USDTSVG } from 'assets/images/home/assets/USDT.svg';
import { ReactComponent as USDCSVG } from 'assets/images/home/assets/USDC.svg';
import { isMobile } from 'react-device-detect';
// import styled from 'styled-components';

// const StyledIcon = styled.svg`
//     width: ${({ width }) => (width || 30) + 'px'};
//     height: ${({ height }) => (height || 30) + 'px'};
// `

const getAssetIcon = (asset: string) => {
    if (['BTC', 'BTCB', 'WGBTC', 'ArtBTCB', 'ArtBTC'].includes(asset)) {
        return BTCSVG;
    } else if (['DOGE', 'DOGEB', 'ArtDOGEB'].includes(asset)) {
        return DOGESVG;
    } else if (['ETH', 'WETH'].includes(asset)) {
        return ETHSVG;
    } else if (['USDT'].includes(asset)) {
        return USDTSVG;
    } else if (['USDC', 'USDC.e'].includes(asset)) {
        return USDCSVG;
    }
    return null;
};

interface AssetIconProps {
    asset: string;
    size?: number;
    mobileSize?: number;
}

const AssetIcon = ({ asset, size = 30, mobileSize = 20 }: AssetIconProps) => {
    const Icon = getAssetIcon(asset);
    return Icon && <Icon width={isMobile ? mobileSize : size} height={isMobile ? mobileSize : size} />;
};

export default AssetIcon;
